export enum RippleState {
  FadingIn = 'FADING_IN',
  FadingOut = 'FADING_OUT',
}
